import { Fragment } from "react"
import SignupModal from "./SignUpModal"
import { Link } from "react-router-dom"
import "./Announcement.css"



const Announcement = () => {
    return (
        <Fragment>
            <div className="announcementBar">
                <div className="l-sec flex items-center justify-end w-100">
                    <Link to={"/gurmatquiz"}>
                        <button aria-label="Join Free Santhya and Punjabi Class">
                            Gurmat Quiz
                        </button></Link>
                    <Link to={"/meet"}>
                        <button class="blinking-button" aria-label="Join Free Santhya and Punjabi Class">
                            Join Free Class
                        </button></Link>
                    <SignupModal />
                    <Link to={"/scholarship"}>Scholarship Form</Link>
                    <Link to={"tel:917351973529"}> +91 7351973529</Link>
                </div>
            </div>
        </Fragment>
    )
}

export default Announcement;